import { Channel } from "stoat.js";

const CHANNEL_ICONS = {
  TEXT_SIDEBAR: "grid_3x3",
  TEXT_MENTION: "tag",
  VOICE: "headset_mic",
} as const;

/**
 * Returns the icon for a given channel
 * @param channel channel to fetch icon for
 * @param context defaults to sidebar, use "mention" for _MENTION icon
 */
export function getChannelIcon(
  channel?: Channel,
  context: "sidebar" | "mention" = "sidebar",
): string {
  if (channel?.type === "TextChannel" && channel?.isVoice)
    return CHANNEL_ICONS.VOICE;

  if (context === "mention") return CHANNEL_ICONS.TEXT_MENTION;

  // Majalis: choose the icon from the channel's name
  const name = (channel?.name ?? "").trim();
  if (/library$/i.test(name)) return "menu_book";
  if (/^schedule$/i.test(name)) return "calendar_month";
  if (/^announcements?$/i.test(name)) return "campaign";

  return "chat_bubble";
}
